<template>
  <o-form :title="$t('medtastic.workshop')" :url="'/api/medtastic/workshops/' + $route.params.id"
          class="ortic-form-horizontal view-form" v-bind:class="{ 'col-lg-8 m-auto': !user }" :enableSave="false">
    <template slot-scope="props">
      <b-row>
        <b-col>
          <o-input :errorField="'title'" :label="$t('core.title')" v-model="props.item.title" :readonly="true"/>
          <o-input :label="$t('medtastic.location')" v-model="props.item.location" :readonly="true"/>
          <o-value-select :errorField="'language'" :items="workshop_locale" :label="$t('core.language')" v-model="props.item.language" :readonly="true"/>
          <o-datepicker :errorField="'date'" :label="$t('core.date')" v-model="props.item.date" :disabled="true"/>
          <o-form-group :label="$t('core.description')">
            <div class="input-group">
              <div v-html="props.item.description"></div>
            </div>
          </o-form-group>
          <o-input :label="$t('medtastic.document')" v-bind:value="props.item.pdf_document ? props.item.pdf_document.name : ''" :readonly="true"/>
        </b-col>
        <b-col v-if="user">
        </b-col>
      </b-row>
    </template>
  </o-form>
</template>

<style>
  .view-form .form-control:disabled, .view-form .form-control[readonly], .view-form .custom-select {
    background-color: #ffffff !important;
    border:none;
    background: none !important;
  }
  .view-form .input-group-append {
    display: none;
  }
</style>
<script>
  import {mapGetters} from 'vuex'

  export default {
    data: () => ({
      workshop_locale: window.config.workshop_locale
    }),
    computed: {
      ...mapGetters({
        user: 'auth/user'
      })
    },
  }
</script>

